<template>
  <!-- MOBILE -->
  <div
    v-if="isMobile === 'mobile'"
    class="d-flex justify-content-around border-bottom"
    :class="isMobile === 'mobile' ? 'flex-column align-items-center' : ''"
  >
    <div
      class="d-flex flex-column"
      :class="isMobile === 'mobile' ? 'w-100 align-items-center' : 'w-75'"
    >
      <div v-if="query.ownerName" class="my-2 w-75">
        <label :for="`${index}-name`"><b>Name:</b></label
        ><br />
        <div
          class="border rounded w-100 param-container d-flex align-items-center justify-content-start"
          :class="query.ownerName ? 'bg-secondary' : 'bg-gray-transparent'"
        >
          <span :id="`${index}-name`" class="px-2 text-black-50 fw-bolder">{{
            query.ownerName || ""
          }}</span>
        </div>
      </div>
      <div v-if="query.address" class="my-2 w-75">
        <label :for="`${index}-address`"><b>Address:</b></label
        ><br />
        <div
          class="border rounded w-100 param-container d-flex align-items-center justify-content-start"
          :class="query.address ? 'bg-secondary' : 'bg-gray-transparent'"
        >
          <span :id="`${index}-address`" class="px-2 text-black-50 fw-bolder">{{
            query.address || ""
          }}</span>
        </div>
      </div>
      <div v-if="query.parcelNumber" class="my-2 w-75">
        <label :for="`${index}-parcel-number`"><b>Parcel Number:</b></label
        ><br />
        <div
          class="border rounded w-100 param-container d-flex align-items-center justify-content-start"
          :class="query.parcelNumber ? 'bg-secondary' : 'bg-gray-transparent'"
        >
          <span
            :id="`${index}-parcel-number`"
            class="px-2  text-black-50 fw-bolder"
            >{{ query.parcelNumber || "" }}</span
          >
        </div>
      </div>
      <div v-if="query.duplicateNumber" class="my-2 w-75">
        <label :for="`${index}-duplicate-number`"><b>Duplicate:</b></label
        ><br />
        <div
          class="border rounded w-100 param-container d-flex align-items-center justify-content-start"
          :class="
            query.duplicateNumber ? 'bg-secondary' : 'bg-gray-transparent'
          "
        >
          <span
            :id="`${index}-duplicate-number`"
            class="px-2  text-black-50 fw-bolder"
            >{{ query.duplicateNumber || "" }}</span
          >
        </div>
      </div>
    </div>

    <div
      class="d-flex m-auto"
      :class="isMobile === 'mobile' ? 'w-50 mb-3' : 'w-25'"
    >
      <button
        class="dropdown-button rounded flex-button button-label border-0 shadow"
        @click="searchForRecent"
      >
        <SearchSVG :fillColor="'white'" /> &nbsp;&nbsp;
        <span>SEARCH</span>
      </button>
    </div>
  </div>
  <!-- DESKTOP -->
  <tr v-else class="w-100" :id="`${index}-search-row`" @click="searchForRecent">
    <td class="p-1 text-center align-middle min-height-3rem bg-transparent">
      <span :id="`${index}-name`" class="fs-6 fw-bolder table-param">{{
        query.ownerName || ""
      }}</span>
    </td>
    <td class="p-1 text-center align-middle bg-transparent">
      <span :id="`${index}-address`" class="fs-6 fw-bolder table-param">{{
        query.address || ""
      }}</span>
    </td>
    <td class="p-1 text-center align-middle bg-transparent">
      <span :id="`${index}-parcel-number`" class="fs-6 fw-bolder table-param">{{
        query.parcelNumber || ""
      }}</span>
    </td>
    <td class="p-1 text-center align-middle bg-transparent">
      <span
        :id="`${index}-duplicate-number`"
        class="fs-6 fw-bolder table-param"
      >
        {{ query.duplicateNumber || "" }}</span
      >
    </td>
  </tr>
</template>
<style scoped>
.param-container {
  min-height: 2rem;
  font-size: 1rem;
}

tr {
  position: relative;
}
td {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
tr::after {
  content: "Click to Search!";
  position: absolute;
  color: white;
  opacity: 0.8;
  text-align: center;
  font-size: 2rem;
  line-height: 4rem;
  top: 0;
  left: 0;
  display: none;
}
tr:hover {
  background-color: rgba(0, 85, 86, 0.6);
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border: 1px solid rgba(0, 0, 0, 1);
}
tr:hover td {
  border-color: rgba(0, 85, 86, 0.6);
}
tr:hover::after {
  display: block;
  width: 100%;
  height: 4rem;
}
tr:hover .table-param {
  color: rgba(0, 0, 0, 0.6);
}

tr td {
  width: 25%;
  min-width: 25%;
  position: static;
}
.min-height-3rem {
  height: 4rem;
}
</style>
<script>
import SearchSVG from "../svg/SearchSVG.vue";
export default {
  components: {
    SearchSVG,
  },
  methods: {
    searchForRecent: function() {
      if (this.status !== "ready") {
        this.updateStatus();
      }
      this.updateFormFields(this.query);

      this.hideBackdrop("recent-searches-modal");
      if (!this.isEquivalent(this.$route.query, this.query)) {
        this.$router.push({ query: this.query });
      }
    },
    isEquivalent(a, b) {
      var aProps = Object.getOwnPropertyNames(a);
      var bProps = Object.getOwnPropertyNames(b);
      if (aProps.length != bProps.length) {
        return false;
      }
      for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
          return false;
        }
      }
      return true;
    },
  },
  props: {
    search: {
      type: Object,
      required: true,
    },
    query: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    updateFormFields: {
      type: Function,
      required: true,
    },
    status: {
      // ready|cancelled|searching|error|recentParcels
      type: String,
      required: true,
    },
    updateStatus: {
      type: Function,
      required: true,
    },
    countySlug: {
      type: String,
      required: true,
    },
    hideBackdrop: {
      type: Function,
      required: true,
    },
  },
};
</script>
